import { motionTokens, createPresenceComponent } from '@fluentui/react-motion';
/** Define a presence motion for fade in/out  */ export const createFadePresence = ({ enterDuration = motionTokens.durationNormal, enterEasing = motionTokens.curveEasyEase, exitDuration = enterDuration, exitEasing = enterEasing } = {})=>({
        enter: {
            duration: enterDuration,
            easing: enterEasing,
            keyframes: [
                {
                    opacity: 0
                },
                {
                    opacity: 1
                }
            ]
        },
        exit: {
            duration: exitDuration,
            easing: exitEasing,
            keyframes: [
                {
                    opacity: 1
                },
                {
                    opacity: 0
                }
            ]
        }
    });
/** A React component that applies fade in/out transitions to its children. */ export const Fade = createPresenceComponent(createFadePresence());
export const FadeSnappy = createPresenceComponent(createFadePresence({
    enterDuration: motionTokens.durationFast
}));
export const FadeRelaxed = createPresenceComponent(createFadePresence({
    enterDuration: motionTokens.durationGentle
}));
